import styles from './dashboard-chart.module.scss';
import React from 'react';
import { EmptyChartIcon } from 'components/icons';
import CompleteAccountModal from './complete-account-modal';
import { useHistory } from 'react-router';

export default function EmptyChart({ accountChecker, ownerType }) {
  const { complete } = accountChecker;
  const [showAccountNotCompleteModal, setShowAccountNotCompleteModal] =
    React.useState(false);
  const history = useHistory();

  const handleAccountModal = () => {
    setShowAccountNotCompleteModal(true);
  };
  const gotoOnboarding = () => {
    history.push({
      pathname: '/onboarding',
      state: {
        accountChecker,
      },
    });
  };
  return (
    <>
      <CompleteAccountModal
        showModal={showAccountNotCompleteModal}
        ownerType={ownerType}
        onClick={gotoOnboarding}
        handleClose={() => {
          setShowAccountNotCompleteModal(false);
        }}
      />
      <div className={styles.chart}>
        <div className={styles.left}>
          <div className={styles.leftGroup}>
            {complete && (
              <div className={styles.group}>
                <p className={styles.label}>Total value</p>
                <p className={styles.amount}>
                  <span className={styles.currency}>₦</span>
                  <span>0.00</span>
                </p>
              </div>
            )}
            {complete && (
              <div className={styles.group}>
                <p className={styles.label}>Total volume</p>
                <p className={styles.amount}>
                  <span className={styles.currency}>₦</span>
                  <span>0.00</span>
                </p>
              </div>
            )}
            <div className={`${styles.group} ${styles.mobile}`}>
              <p className={styles.label}>Available balance</p>
              <div className={styles.amount}>
                <span className={styles.currency}>₦</span>
                <span>0.00</span>
                <div className={styles.buttons}>
                  <button
                    className={styles.button}
                    onClick={handleAccountModal}
                  >
                    Withdraw
                  </button>
                  {/* <button
                    className={styles.button}
                    onClick={handleAccountModal}
                  >
                    Top Up
                  </button> */}
                </div>
              </div>
            </div>
            <div className={styles.group}></div>
          </div>
          <div className={styles.emptyState}>
            <EmptyChartIcon />
            <h3>There’s nothing to see here</h3>
            <p>
              Your business performance will show up here when you start making
              sales.
            </p>
          </div>
        </div>
        <div className={styles.right}>
          {complete && (
            <div className={styles.group}>
              <p className={styles.label}>Available balance</p>
              <p className={styles.amount}>
                <span className={styles.currency}>₦</span>
                <span>0.00</span>
              </p>
            </div>
          )}
          <div className={styles.buttons}>
            <button className={styles.button} onClick={handleAccountModal}>
              Withdraw
            </button>
            {/* <button className={styles.button} onClick={handleAccountModal}>
              Top Up
            </button> */}
          </div>
        </div>
      </div>
    </>
  );
}
